import { render, staticRenderFns } from "./BaseDrawer.vue?vue&type=template&id=40dc52b6&scoped=true&"
import script from "./BaseDrawer.vue?vue&type=script&lang=js&"
export * from "./BaseDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BaseDrawer.vue?vue&type=style&index=0&id=40dc52b6&lang=scss&scoped=true&"
import style1 from "./BaseDrawer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dc52b6",
  null
  
)

export default component.exports